'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackendUserProvider = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AbstractUserProvider2 = require('./AbstractUserProvider');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let BackendUserProvider = exports.BackendUserProvider = function (_AbstractUserProvider) {
  _inherits(BackendUserProvider, _AbstractUserProvider);

  /**
   * @param {String} userModelName
   * @param {*} deepDb
   */
  function BackendUserProvider(userModelName, deepDb) {
    _classCallCheck(this, BackendUserProvider);

    var _this = _possibleConstructorReturn(this, (BackendUserProvider.__proto__ || Object.getPrototypeOf(BackendUserProvider)).call(this));

    _this.userModelName = userModelName;
    _this.deepDb = deepDb;
    return _this;
  }

  /**
   * @param {String} id
   * @param {Function} callback
   */


  _createClass(BackendUserProvider, [{
    key: 'loadUserByIdentityId',
    value: function loadUserByIdentityId(id, callback) {
      let userModel = null;

      if (this.deepDb.has(this.userModelName)) {
        userModel = this.deepDb.get(this.userModelName);
      }

      if (!userModel) {
        callback(null, null);
        return;
      }

      userModel.findOneById(id, (error, item) => {
        callback(error, item && item.get());
      });
    }
  }]);

  return BackendUserProvider;
}(_AbstractUserProvider2.AbstractUserProvider);


//////////////////
// WEBPACK FOOTER
// ../~/deep-security/lib.compiled/BackendUserProvider.js
// module id = 432
// module chunks = 0